import React, { useState } from 'react';

function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "How long does it take to build a website?",
      answer: "Most websites are completed within 2-3 weeks. E-commerce sites take 3-4 weeks, and mobile apps typically take 4-6 weeks. We'll give you a specific timeline after discussing your project."
    },
    {
      question: "Do I need to provide content and images?",
      answer: "While you can provide your own content, we also offer content writing and professional stock photos as part of our service. We'll help you create compelling content that converts visitors into customers."
    },
    {
      question: "What if I'm not satisfied with the final result?",
      answer: "We offer unlimited revisions during the development process and a 100% money-back guarantee within 30 days if you're not completely satisfied. Your success is our priority."
    },
    {
      question: "Do you provide ongoing support after launch?",
      answer: "Yes! All packages include free support (30 days to 1 year depending on package). After that, we offer affordable monthly maintenance plans starting at $99/month for updates, security, and technical support."
    },
    {
      question: "Can you help with SEO and Google rankings?",
      answer: "Absolutely! All our websites include basic SEO setup. We can also provide advanced SEO services including keyword research, content optimization, and ongoing SEO management to help you rank higher on Google."
    },
    {
      question: "What payment methods do you accept?",
      answer: "We accept all major credit cards, PayPal, bank transfers, and Zelle. Payment is split: 50% upfront to start, 50% upon completion. We also offer 3-month payment plans for projects over $2,000."
    },
    {
      question: "Will my website work on mobile phones?",
      answer: "Yes! Every website we build is fully responsive and optimized for mobile devices, tablets, and desktops. With 60%+ of traffic coming from mobile, this is standard in all our projects."
    },
    {
      question: "Can I update the website myself after it's built?",
      answer: "Yes! We build most sites on user-friendly platforms like WordPress so you can easily update content, add blog posts, and make changes. We also provide training videos and documentation."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq">
      <div className="faq-container">
        <div className="faq-header">
          <div className="section-label">FREQUENTLY ASKED QUESTIONS</div>
          <h2 className="faq-title">Got Questions? We've Got Answers</h2>
          <p className="faq-subtitle">
            Everything you need to know about our services and process
          </p>
        </div>

        <div className="faq-grid">
          <div className="faq-list">
            {faqs.map((faq, index) => (
              <div key={index} className={`faq-item ${openIndex === index ? 'open' : ''}`}>
                <button 
                  className="faq-question"
                  onClick={() => toggleFAQ(index)}
                >
                  <span>{faq.question}</span>
                  <span className="faq-icon">{openIndex === index ? '−' : '+'}</span>
                </button>
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="faq-cta-box">
            <h3>Still have questions?</h3>
            <p>Can't find the answer you're looking for? Our team is here to help!</p>
            <a href="#contact" className="faq-cta-btn">
              📞 Call Us Now
            </a>
            <a href="mailto:hello@techowdy.com" className="faq-cta-btn secondary">
              ✉️ Send Email
            </a>
            <div className="faq-guarantee">
              <div className="guarantee-badge">⚡</div>
              <div>
                <strong>Fast Response</strong>
                <p>We typically respond within 1 hour during business hours</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FAQ;
